import { render, staticRenderFns } from "./TcmPrintPrecription.vue?vue&type=template&id=d47893ba&"
import script from "./TcmPrintPrecription.vue?vue&type=script&lang=js&"
export * from "./TcmPrintPrecription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports